<template>
  <div class="avatar" :style="style"></div>
</template>

<script>
export default {
  name: 'Avatar',

  props: {
    size: {
      type: [Number, String],
      default: 55
    },

    rounded: {
      type: Boolean,
      default: true
    },

    color: {
      type: String
    },

    url: {
      type: String
    }
  },

  data() {
    return {
      backgroundColors: ['#0b96e9', '#32acf5', '#d5eefd', '#eef8ff']
    };
  },

  computed: {
    style() {
      const style = {
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderRadius: this.rounded ? '50%' : 0,
        backgroundColor:
          this.color ||
          this.backgroundColors[Math.floor(Math.random() * this.backgroundColors.length)],
        backgroundImage: `url(${this.url})`
      };

      return style;
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  flex-shrink: 0;
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
